/*
 * Minicart: fecha de entrega.
 *  - Muestra en la línea de entrega la fecha elegida por el cliente (no el "próximo jueves"
 *    que calcula el componente React de Permalink).
 *  - Inyecta un botón "Cambiar fecha" + calendario (solo jueves) reusando los estilos pdp2-cal.
 *  - Al elegir fecha: guarda en localStorage, actualiza el ATRIBUTO de carrito y las
 *    PROPIEDADES de línea de cada producto -> la fecha viaja al pedido (admin Shopify).
 * La fecha real ya se setea también desde la PDP; esto mantiene todo en sync desde el carrito.
 */

// ---------- Cache de catálogo (rendimiento del carrito) ----------
// El bundle pide /products/{handle}.js y /collections/all/products.json en CADA cambio del
// carrito (para precios/compare_at y candidatos de upsell). Esos datos NO cambian en la sesión,
// así que los memoizamos: el primer cambio los pide, los siguientes los sirven de cache -> fluido.
(function () {
  if (window.__carlesFetchCached) return;
  window.__carlesFetchCached = true;
  var orig = window.fetch;
  var cache = new Map();
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = (init && init.method) || (input && input.method) || 'GET';
      if (String(method).toUpperCase() === 'GET' && /(\/products\/[^/?#]+\.js)([?#]|$)|(\/collections\/all\/products\.json)/.test(url)) {
        var hit = cache.get(url);
        if (hit) return Promise.resolve(hit.clone());
        return orig.apply(this, arguments).then(function (resp) {
          if (resp && resp.ok) { try { cache.set(url, resp.clone()); } catch (e) {} }
          return resp;
        });
      }
    } catch (e) {}
    return orig.apply(this, arguments);
  };
})();

(function () {
  var MESES_ES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  var MESOS_CA = ['gener', 'febrer', 'març', 'abril', 'maig', 'juny', 'juliol', 'agost', 'setembre', 'octubre', 'novembre', 'desembre'];
  var DOWS_CA = ['dl', 'dt', 'dc', 'dj', 'dv', 'ds', 'dg'];
  var DOWS_ES = ['lu', 'ma', 'mi', 'ju', 'vi', 'sá', 'do'];

  function pad(n) { return ('0' + n).slice(-2); }
  function parseISO(s) { var p = s.split('-'); return new Date(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10)); }
  function today0() { var t = new Date(); return new Date(t.getFullYear(), t.getMonth(), t.getDate()); }
  // Días de entrega configurables desde Configuración del tema (array 0=domingo..6=sábado; def. [4]=jueves)
  var DDAYS = (typeof window !== 'undefined' && window.CARLES_DELIVERY_DAYS && window.CARLES_DELIVERY_DAYS.length) ? window.CARLES_DELIVERY_DAYS : [4];
  function isDeliveryDay(d) { return DDAYS.indexOf(d.getDay()) !== -1; }
  function getNextThursday(date) { var d = new Date(date.getFullYear(), date.getMonth(), date.getDate()); for (var i = 1; i <= 14; i++) { var c = new Date(d.getFullYear(), d.getMonth(), d.getDate() + i); if (isDeliveryDay(c)) return c; } return d; }
  function sameDay(a, b) { return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }

  var DIAS_ES = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  // Texto del minicart estilo Figma: "jueves 2 octubre" (día de la semana, sin cero ni "de")
  function fmtEs(d) { return DIAS_ES[d.getDay()] + ' ' + d.getDate() + ' ' + MESES_ES[d.getMonth()]; }
  // Mismo formato en catalán para el TEXTO visible del carrito: "dijous 2 octubre"
  var DIES_CA = ['diumenge', 'dilluns', 'dimarts', 'dimecres', 'dijous', 'divendres', 'dissabte'];
  function isCaLang() { return (document.documentElement.lang || '').slice(0, 2) === 'ca'; }
  function fmtDisplay(d) { return isCaLang() ? (DIES_CA[d.getDay()] + ' ' + d.getDate() + ' ' + MESOS_CA[d.getMonth()]) : fmtEs(d); }
  // Valor de propiedad/atributo (catalán con conector, IGUAL que la PDP -> consistencia)
  function fmtCa(d) { var mes = MESOS_CA[d.getMonth()]; var con = /^[aeiou]/i.test(mes) ? " d'" : ' de '; return pad(d.getDate()) + con + mes; }
  function fmtCaYear(d) { return fmtCa(d) + ' de ' + d.getFullYear(); }

  function selectedDate() {
    try {
      var s = localStorage.getItem('carles_delivery_date');
      if (s && /^\d{4}-\d{2}-\d{2}$/.test(s)) { var d = parseISO(s); if (isDeliveryDay(d) && d >= today0()) return d; }
    } catch (e) {}
    return null;
  }

  // ---------- Texto de la línea de entrega ----------
  function deliveryLines() { return document.querySelectorAll('.i-minicart-container__snap--delivery'); }
  function deliveryTextNodes() {
    var n = document.querySelectorAll('.i-minicart-container__snap--delivery__text, .i-minicart-container [class*="delivery__text"]');
    if (n.length) return n;
    var out = [], all = document.querySelectorAll('.i-minicart-container__snap--delivery *');
    for (var i = 0; i < all.length; i++) { if (all[i].children.length === 0 && /Entrega/.test(all[i].textContent || '')) out.push(all[i]); }
    return out;
  }
  function applyText() {
    var d = selectedDate() || getNextThursday(new Date());
    var pk = window.CARLES_PICKUP && window.CARLES_PICKUP.on;
    var want = (pk ? (isCaLang() ? window.CARLES_PICKUP.ca : window.CARLES_PICKUP.es) : 'Entrega el') + ' ' + fmtDisplay(d);
    var nodes = deliveryTextNodes();
    for (var i = 0; i < nodes.length; i++) { if (nodes[i].textContent !== want) nodes[i].textContent = want; }
  }

  // ---------- Calendario (solo jueves) ----------
  function buildCalendarHTML(viewY, viewM, selected) {
    var first = new Date(viewY, viewM, 1);
    var startOffset = (first.getDay() + 6) % 7;
    var daysInMonth = new Date(viewY, viewM + 1, 0).getDate();
    var t0 = today0();
    var ca = isCaLang();
    var MESES = ca ? MESOS_CA : MESES_ES;
    var DOWS = ca ? DOWS_CA : DOWS_ES;
    var atMin = (viewY < t0.getFullYear()) || (viewY === t0.getFullYear() && viewM <= t0.getMonth());
    var html = '<div class="pdp2-cal__head">' +
      '<button type="button" class="pdp2-cal__nav" data-cal-prev aria-label="' + (ca ? 'Mes anterior' : 'Mes anterior') + '"' + (atMin ? ' disabled' : '') + '>‹</button>' +
      '<span class="pdp2-cal__title">' + MESES[viewM] + ' ' + viewY + '</span>' +
      '<button type="button" class="pdp2-cal__nav" data-cal-next aria-label="' + (ca ? 'Mes següent' : 'Mes siguiente') + '">›</button></div>';
    html += '<div class="pdp2-cal__grid">';
    for (var w = 0; w < 7; w++) html += '<span class="pdp2-cal__dow">' + DOWS[w] + '</span>';
    for (var b = 0; b < startOffset; b++) html += '<span class="pdp2-cal__cell pdp2-cal__cell--empty"></span>';
    for (var dn = 1; dn <= daysInMonth; dn++) {
      var cd = new Date(viewY, viewM, dn);
      var ok = isDeliveryDay(cd) && (cd > t0);
      var cls = 'pdp2-cal__cell ' + (ok ? 'pdp2-cal__cell--day' : 'pdp2-cal__cell--off');
      if (sameDay(cd, selected)) cls += ' pdp2-cal__cell--sel';
      var attrs = ok ? ' data-cal-day="' + viewY + '-' + pad(viewM + 1) + '-' + pad(dn) + '" tabindex="0" role="button"' : ' aria-disabled="true"';
      html += '<span class="' + cls + '"' + attrs + '>' + dn + '</span>';
    }
    // Tamaño CONSTANTE: rellenar siempre hasta 6 filas (42 celdas) para que el calendario no
    // cambie de alto según el mes y las flechas no se muevan al pasar de mes.
    var totalCells = startOffset + daysInMonth;
    for (var tp = totalCells; tp < 42; tp++) html += '<span class="pdp2-cal__cell pdp2-cal__cell--empty"></span>';
    var dnames = DDAYS.slice().sort(function (a, b) { return (a === 0 ? 7 : a) - (b === 0 ? 7 : b); }).map(function (x) { var n = ca ? DIES_CA[x] : DIAS_ES[x]; return /s$/.test(n) ? n : n + 's'; });
    var djoin = dnames.length > 1 ? (dnames.slice(0, -1).join(', ') + (ca ? ' i ' : ' y ') + dnames[dnames.length - 1]) : (dnames[0] || '');
    var pkn = window.CARLES_PICKUP && window.CARLES_PICKUP.on;
    var srt = DDAYS.slice().sort(function (a, b) { return (a === 0 ? 7 : a) - (b === 0 ? 7 : b); });
    var seguidos = srt.length > 2 && srt.every(function (d, i) { return i === 0 || ((d === 0 ? 7 : d) - (srt[i - 1] === 0 ? 7 : srt[i - 1])) === 1; });
    var noteTxt;
    if (pkn) {
      var nm = function (x) { return ca ? DIES_CA[x] : DIAS_ES[x]; };
      noteTxt = (ca ? window.CARLES_PICKUP.note_ca : window.CARLES_PICKUP.note_es) + ' ' + (seguidos
        ? (ca ? ('de ' + nm(srt[0]) + ' a ' + nm(srt[srt.length - 1])) : ('de ' + nm(srt[0]) + ' a ' + nm(srt[srt.length - 1])))
        : ((ca ? 'els ' : 'los ') + djoin));
    } else {
      noteTxt = ca ? ('Només lliurem els ' + djoin) : ('Solo entregamos los ' + djoin);
    }
    html += '</div><p class="pdp2-cal__note">' + noteTxt + '</p>';
    return html;
  }

  // ---------- Guardar fecha en carrito + pedido ----------
  function persist(iso) {
    try { localStorage.setItem('carles_delivery_date', iso); } catch (e) {}
    var caStr = fmtCaYear(parseISO(iso));
    // Atributo de carrito (nivel pedido -> "Detalles adicionales")
    try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Fecha de entrega': caStr } }) }); } catch (e) {}
    // Propiedades de línea de cada producto del carrito
    try {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var chain = Promise.resolve();
        (cart.items || []).forEach(function (it) {
          var props = Object.assign({}, it.properties || {}, { 'Fecha de entrega': caStr });
          chain = chain.then(function () {
            return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props }) });
          });
        });
        return chain;
      }).then(function () {
        if (window.Permalink && window.Permalink.reactive) { try { window.Permalink.reactive(); } catch (e) {} }
        setTimeout(applyText, 200);
      }).catch(function () {});
    } catch (e) {}
    applyText();
    try { window.dispatchEvent(new CustomEvent('carles:delivery-change', { detail: { value: iso } })); } catch (e) {}
  }

  // ---------- Inyectar "Cambiar fecha" + popover ----------
  function injectChanger() {
    var lines = deliveryLines();
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (line.querySelector('.carles-mc-change')) continue;
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'pdp2-delivery__change carles-mc-change'; btn.textContent = isCaLang() ? 'Canviar data' : 'Cambiar fecha';
      var cal = document.createElement('div'); cal.className = 'pdp2-calendar carles-minicart-cal'; cal.hidden = true; cal.setAttribute('role', 'dialog'); cal.setAttribute('aria-label', isCaLang() ? "Triar data d'entrega" : 'Elegir fecha de entrega');
      line.appendChild(btn); line.appendChild(cal);

      (function (btn, cal) {
        var viewY, viewM;
        function render() { var sel = selectedDate() || getNextThursday(new Date()); cal.innerHTML = buildCalendarHTML(viewY, viewM, sel); }
        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var willOpen = cal.hidden;
          if (willOpen) { var sel = selectedDate() || getNextThursday(new Date()); viewY = sel.getFullYear(); viewM = sel.getMonth(); render(); }
          cal.hidden = !willOpen;
          // Se abre hacia arriba: si no cabe (pantallas bajas), bajarlo lo justo para que no se corte
          cal.style.transform = '';
          if (willOpen) { var cr = cal.getBoundingClientRect(); if (cr.top < 8) cal.style.transform = 'translateY(' + Math.ceil(8 - cr.top) + 'px)'; }
        });
        cal.addEventListener('click', function (e) {
          e.stopPropagation(); // N5: que el clic en las flechas NO dispare el "cerrar al clic fuera"
          var t0 = today0();
          if (e.target.closest('[data-cal-prev]')) {
            var pm = viewM - 1, py = viewY; if (pm < 0) { pm = 11; py--; }
            if (py < t0.getFullYear() || (py === t0.getFullYear() && pm < t0.getMonth())) return;
            viewM = pm; viewY = py; render(); return;
          }
          if (e.target.closest('[data-cal-next]')) {
            var nm = viewM + 1, ny = viewY; if (nm > 11) { nm = 0; ny++; }
            var max = new Date(t0.getFullYear() + 1, t0.getMonth(), 1); // tope = hoy + 12 meses
            if (ny > max.getFullYear() || (ny === max.getFullYear() && nm > max.getMonth())) return;
            viewM = nm; viewY = ny; render(); return;
          }
          var day = e.target.closest('[data-cal-day]');
          if (day) { persist(day.getAttribute('data-cal-day')); cal.hidden = true; }
        });
        cal.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { var day = e.target.closest('[data-cal-day]'); if (day) { e.preventDefault(); persist(day.getAttribute('data-cal-day')); cal.hidden = true; } }
        });
      })(btn, cal);
    }
  }

  // Cerrar el popover al hacer click fuera
  document.addEventListener('click', function (e) {
    var cals = document.querySelectorAll('.carles-minicart-cal');
    for (var i = 0; i < cals.length; i++) {
      var cal = cals[i];
      if (!cal.hidden && !cal.contains(e.target) && !(e.target.closest && e.target.closest('.carles-mc-change'))) cal.hidden = true;
    }
  });

  // ---------- N1: renombrar "TOTAL" -> "SUBTOTAL" (sin línea extra ni fetch que ralentice) ----------
  function renameTotalLabel() {
    var labels = document.querySelectorAll('.i-minicart-container__snap--footer__total--label');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].textContent !== 'SUBTOTAL') labels[i].textContent = 'SUBTOTAL';
    }
    // limpia cualquier línea de subtotal que se hubiera inyectado antes
    var old = document.querySelectorAll('.carles-cart-subtotal');
    for (var j = 0; j < old.length; j++) old[j].remove();
  }

  // ---------- "Te puede gustar": barra de progreso de la marquesina (móvil) ----------
  function injectUpsellBar() {
    var ups = document.querySelectorAll('.i-minicart-container__snap--upsells');
    for (var i = 0; i < ups.length; i++) {
      var up = ups[i];
      var grid = up.querySelector('.i-minicart-container__snap--upsells__grid');
      var title = up.querySelector('.i-minicart-container__snap--upsells__title');
      if (!grid || !title || up.querySelector('.carles-upsell-bar')) continue;
      var bar = document.createElement('div'); bar.className = 'carles-upsell-bar';
      var fill = document.createElement('div'); fill.className = 'carles-upsell-bar__fill';
      bar.appendChild(fill);
      title.insertAdjacentElement('afterend', bar);
      (function (grid, fill, bar) {
        function sync() {
          var sw = grid.scrollWidth, cw = grid.clientWidth;
          if (sw <= 0) return;
          if (sw > cw + 2) {
            bar.style.display = ''; // deja decidir al CSS (visible en móvil)
            fill.style.width = (Math.min(1, cw / sw) * 100) + '%';
            fill.style.marginLeft = ((grid.scrollLeft / sw) * 100) + '%';
          } else {
            bar.style.display = 'none'; // 1 sola tarjeta -> nada que deslizar
          }
        }
        grid.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        setTimeout(sync, 120); setTimeout(sync, 500);
      })(grid, fill, bar);
    }
  }

  // ---------- €/kilo real en los upsells (el /products/{handle}.js NO trae metafields) ----------
  // Cargamos el €/kilo de todos los productos en 1 petición (vista templates/collection.ppk.liquid)
  var ppkMap = null, ppkLoading = false;
  function loadPpkMap() {
    if (ppkMap || ppkLoading) return;
    ppkLoading = true;
    fetch('/collections/all?view=ppk').then(function (r) { return r.json(); }).then(function (d) {
      ppkMap = (d && d.products) || {};
      fixUpsellKilos();
    }).catch(function () { ppkLoading = false; });
  }
  function fixUpsellKilos() {
    if (!ppkMap) { loadPpkMap(); return; }
    var cards = document.querySelectorAll('.i-minicart-upsell-item');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getAttribute('data-ppk-done')) continue;
      var link = card.querySelector('a[href*="/products/"]');
      var ppkEl = card.querySelector('.i-minicart-upsell-item__price-per-kilo');
      if (!link || !ppkEl) continue;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) continue;
      card.setAttribute('data-ppk-done', '1');
      var val = ppkMap[m[1]];
      if (val) { ppkEl.textContent = val + ' €/kilo'; ppkEl.style.display = ''; }
      else { ppkEl.style.display = 'none'; } // sin metafield (venta por unidad) -> sin €/kilo
    }
  }

  // ---------- Scroll-lock: bloquear el fondo al abrir el carrito SIN salto ni cambio de ancho ----------
  // La app NO bloquea el scroll, así que lo hacemos aquí: html overflow:hidden (bloquea sin mover
  // la página, no hay salto) + padding-right en el body = ancho de la barra (para que el header no
  // se ensanche al desaparecer la barra de scroll).
  function syncScrollLock() {
    var de = document.documentElement;
    var open = document.body.classList.contains('open-cart');
    if (open && !de.hasAttribute('data-carles-locked')) {
      var sbw = window.innerWidth - de.clientWidth; // ancho de la barra de scroll
      de.setAttribute('data-carles-locked', '1');
      de.style.overflow = 'hidden';
      if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    } else if (!open && de.hasAttribute('data-carles-locked')) {
      de.removeAttribute('data-carles-locked');
      de.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  // ---------- Móvil: scroll unificado ----------
  // Envuelve productos (--items) + "Te puede gustar" (--upsells) en un contenedor que scrollea
  // juntos. La entrega y el footer quedan FUERA del wrapper (fijos abajo). En escritorio el
  // wrapper es display:contents (transparente) -> el layout de escritorio no cambia.
  // Idempotente: solo toca el DOM si la estructura no está ya montada (evita churn del observer).
  function setupScrollWrapper() {
    var snap = document.querySelector('.i-minicart-container__snap');
    if (!snap) return;
    var items = snap.querySelector('.i-minicart-container__snap--items');
    var upsells = snap.querySelector('.i-minicart-container__snap--upsells');
    var header = snap.querySelector('.i-minicart-container__snap--header');
    if (!items || !upsells || !header) return;
    var wrap = snap.querySelector('.carles-mc-scroll');
    if (wrap && items.parentNode === wrap && wrap.previousElementSibling === header) {
      return; // ya está bien montado
    }
    if (!wrap) { wrap = document.createElement('div'); wrap.className = 'carles-mc-scroll'; }
    header.insertAdjacentElement('afterend', wrap);
    wrap.appendChild(items);
    // #18: los upsells "Te puede gustar" ya NO se meten en el wrapper de scroll → quedan como hijo
    // directo del --snap (fijos, no scrollean con los productos); el CSS los coloca ABAJO (order:3,
    // debajo de "entrega", encima del footer/checkout).
  }

  // ---------- Update OPTIMISTA de cantidad (+/-) ----------
  // El número (un <input type=number readonly>) se actualiza al INSTANTE al pulsar +/-, sin
  // esperar al round-trip. React lo resetea al valor viejo durante el "updating": re-aplicamos
  // nuestro valor (síncrono, en el observer) hasta que el servidor confirma o caduca (4s).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.i-cart-item--actions--qty button');
    if (!btn) return;
    var input = btn.parentNode && btn.parentNode.querySelector('input[type="number"]');
    if (!input) return;
    var cur = parseInt(input.value, 10);
    if (isNaN(cur)) return;
    var next = btn.querySelector('.icon-plus') ? cur + 1 : (btn.querySelector('.icon-minus') ? cur - 1 : cur);
    if (next === cur) return;
    if (next < 1) { input.__carlesPending = null; return; } // bajar a 0 -> el bundle borra la línea
    input.__carlesPending = { target: String(next), until: Date.now() + 4000 };
    input.value = next;
  }, true);
  function applyOptimisticQty() {
    var inputs = document.querySelectorAll('.i-cart-item--actions--qty input[type="number"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i], p = inp.__carlesPending;
      if (!p) continue;
      if (Date.now() > p.until) { inp.__carlesPending = null; continue; }
      if (inp.value !== p.target) inp.value = p.target;
    }
  }

  // ---------- Slide de CIERRE ----------
  // Al cerrar, el bundle oculta el panel de golpe (display:none). Lo mantenemos montado un
  // instante (clase carles-closing) y lo deslizamos fuera con un transform antes de ocultarlo.
  var carlesWasOpen = false;
  function slideOutClose() {
    var im = document.querySelector('i-minicart');
    var snap = im && im.querySelector('.i-minicart-container__snap');
    if (!im || !snap) return;
    im.classList.add('carles-closing');
    void snap.offsetWidth; // reflow: fija el estado inicial (en pantalla) antes de animar
    snap.classList.add('carles-slide-out');
    // Limpieza al TERMINAR la transición real (no a un timeout fijo): así no se cortan los últimos
    // frames del deslizamiento. setTimeout(380) = fallback por si no llega el transitionend.
    var done = function () { im.classList.remove('carles-closing'); snap.classList.remove('carles-slide-out'); snap.removeEventListener('transitionend', onEnd); };
    var onEnd = function (ev) { if (ev.target === snap && ev.propertyName === 'transform') done(); };
    snap.addEventListener('transitionend', onEnd);
    setTimeout(done, 380);
  }
  function onBodyClassChange() {
    syncScrollLock();
    var open = document.body.classList.contains('open-cart');
    if (carlesWasOpen && !open) slideOutClose();
    if (open) {
      var im = document.querySelector('i-minicart');
      if (im) { im.classList.remove('carles-closing'); var sn = im.querySelector('.i-minicart-container__snap'); if (sn) sn.classList.remove('carles-slide-out'); }
    }
    carlesWasOpen = open;
  }

  // ---------- Borrado OPTIMISTA: colapsa la fila al instante (sin esperar al round-trip del bundle) ----------
  (function () {
    var st = document.createElement('style');
    st.textContent = '.i-cart-item{transition:opacity .16s ease,max-height .26s ease,margin .26s ease,padding .26s ease;max-height:500px;overflow:hidden}.i-cart-item.carles-removing{opacity:0!important;max-height:0!important;margin:0!important;padding-top:0!important;padding-bottom:0!important;pointer-events:none}';
    (document.head || document.documentElement).appendChild(st);
  })();
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var row = null;
    var del = e.target.closest('.i-cart-item--delete, .i-cart-item--remove, [data-cart-remove]');
    if (del) { row = del.closest('.i-cart-item'); }
    else {
      var qb = e.target.closest('.i-cart-item--actions--qty button');
      if (qb && qb.querySelector('.icon-minus')) { var inp = qb.parentNode && qb.parentNode.querySelector('input[type="number"]'); if (inp && parseInt(inp.value, 10) <= 1) row = qb.closest('.i-cart-item'); }
    }
    if (row && !row.classList.contains('carles-removing')) { row.classList.add('carles-removing'); scheduleRemovalVerify(); }
  }, true);

  // ---------- Reconciliación anti-"(1) fantasma" ----------
  // El colapso optimista oculta la fila al instante. Si el borrado NO llegó al servidor (p. ej. el
  // bundle no elimina al pulsar "−" en cantidad 1, o falla el último borrado), el conteo del carrito
  // se queda en "(1)" con la fila invisible. Tras el round-trip del bundle consultamos /cart.js:
  //   · servidor AÚN con líneas + filas colapsadas de más -> deshacemos el colapso (la fila reaparece).
  //   · servidor vacío -> avisamos al bundle para que no deje un conteo "(1)" colgado.
  var verifyT = null;
  function scheduleRemovalVerify() {
    if (verifyT) clearTimeout(verifyT);
    verifyT = setTimeout(function () {
      verifyT = null;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart) return;
        var lines = (cart.items && cart.items.length) || 0;
        var removing = document.querySelectorAll('.i-cart-item.carles-removing');
        var visible = document.querySelectorAll('.i-cart-item').length - removing.length;
        if (lines > 0 && removing.length && visible < lines) {
          // El servidor todavía tiene líneas que hemos ocultado -> el borrado no se aplicó: revertir.
          for (var i = 0; i < removing.length; i++) removing[i].classList.remove('carles-removing');
        } else if (lines === 0) {
          // Carrito realmente vacío -> empujar al bundle a refrescar para que no quede un "(1)" fantasma.
          try { window.dispatchEvent(new CustomEvent('cartUpdate')); } catch (e) {}
          try { window.dispatchEvent(new CustomEvent('cartToggle')); } catch (e) {}
          if (window.Permalink && window.Permalink.reactive) { try { window.Permalink.reactive(); } catch (e) {} }
        }
      }).catch(function () {});
    }, 650);
  }

  // ---------- Carrito en CATALÁN (el bundle React rotula en español; en /es se deja español) ----------
  function cartTextCa() {
    if ((document.documentElement.lang || '').slice(0, 2) !== 'ca') return;
    var mc = document.querySelector('i-minicart'); if (!mc) return;
    var map = { 'Carrito': 'Cistella', 'Carrito vacio': 'La cistella és buida', 'Carrito vacío': 'La cistella és buida', 'Cargando items...': 'Carregant…', 'Cargando...': 'Carregant…', 'Tu carrito': 'La teva cistella', 'Vaciar': 'Buidar', 'Seguir comprando': 'Seguir comprant', 'Finalizar compra': 'Finalitzar la compra', 'Tramitar pedido': 'Tramitar la comanda', 'Subtotal': 'Subtotal', 'Te puede gustar': 'Et pot agradar', 'También te puede gustar': 'També et pot agradar', 'Añadir': 'Afegir', 'Añadir al carrito': 'Afegir a la cistella', 'PAGO SEGURO': 'PAGAMENT SEGUR', 'Pago seguro': 'Pagament segur', 'Cambiar fecha': 'Canviar data', 'Eliminar': 'Eliminar', 'Cantidad': 'Quantitat' };
    var w = document.createTreeWalker(mc, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) { var t = n.nodeValue.trim(); if (t && map[t]) { var rep = n.nodeValue.replace(t, map[t]); if (n.nodeValue !== rep) n.nodeValue = rep; } }
  }

  // ---------- Pedidos por WhatsApp (modo sin pago online) ----------
  // Cuando Configuración del tema → "Pedidos por WhatsApp" está activo, el minicart NO cobra online:
  // el botón de checkout del footer se oculta por CSS (body.carles-wa-mode, en theme.liquid) y aquí
  // inyectamos un botón que abre WhatsApp con el carrito + la fecha de recogida ya redactados.
  var WA = (typeof window !== 'undefined' && window.CARLES_WHATSAPP) ? window.CARLES_WHATSAPP : { on: false };
  function waMoney(cents) {
    var v = (cents || 0) / 100;
    try { return v.toLocaleString(isCaLang() ? 'ca-ES' : 'es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
    catch (e) { return v.toFixed(2).replace('.', ',') + ' €'; }
  }
  function waText(cart) {
    var ca = isCaLang();
    var out = [ca ? WA.intro_ca : WA.intro_es, ''];
    (cart.items || []).forEach(function (it) {
      var title = it.product_title || it.title || '';
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? ' (' + it.variant_title + ')' : '';
      out.push('• ' + it.quantity + '× ' + title + vt);
    });
    out.push('');
    out.push(ca ? 'Recollida a botiga' : 'Recogida en tienda');
    // Fecha = la que ve el cliente en el carrito (elegida o el próximo día de entrega), en su idioma
    var d = selectedDate() || getNextThursday(new Date());
    var fecha = ca ? (DIES_CA[d.getDay()] + ' ' + fmtCa(d) + ' de ' + d.getFullYear())
                   : (DIAS_ES[d.getDay()] + ' ' + d.getDate() + ' de ' + MESES_ES[d.getMonth()] + ' de ' + d.getFullYear());
    out.push((ca ? 'Data de recollida: ' : 'Fecha de recogida: ') + fecha);
    var hora = getHour() || (cart.attributes && cart.attributes['Hora de recogida']) || '';
    if (hora) out.push((ca ? 'Hora de recollida: ' : 'Hora de recogida: ') + hora);
    if (!WA.show_price) return out.join('\n'); // precios orientativos: se paga en tienda
    // Código de descuento aplicado al carrito (/discount/CODIGO o AJAX): total_price ya viene descontado.
    // Nombres de TODOS los descuentos aplicados (código y automáticos) para no atribuir al código lo que no es suyo
    var codes = [];
    (cart.cart_level_discount_applications || []).forEach(function (d) { if (d && d.title && codes.indexOf(d.title) < 0) codes.push(d.title); });
    (cart.items || []).forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { var t = a && a.discount_application && a.discount_application.title; if (t && codes.indexOf(t) < 0) codes.push(t); }); });
    var saved = (cart.original_total_price || 0) - (cart.total_price || 0);
    if (saved > 0) {
      out.push('Subtotal: ' + waMoney(cart.original_total_price));
      out.push((ca ? 'Descompte' : 'Descuento') + (codes.length ? ' (' + codes.join(', ') + ')' : '') + ': -' + waMoney(saved));
    }
    out.push('Total: ' + waMoney(cart.total_price));
    return out.join('\n');
  }
  function waOpen() {
    if (hourMissing()) return; // obligatorio elegir la hora de recogida
    // /cart.js con el prefijo de idioma (/es/) -> títulos de producto en el idioma del cliente
    var waRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(waRoot + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart || !(cart.items && cart.items.length)) return;
      var num = String(WA.num || '').replace(/[^\d]/g, ''); // wa.me = solo dígitos (prefijo país incluido, sin +)
      if (!num) return;
      var url = 'https://wa.me/' + num + '?text=' + encodeURIComponent(waText(cart));
      // iOS Safari bloquea window.open tras un fetch (no es gesto directo) -> abrir en la misma pestaña
      var w = window.open(url, '_blank');
      if (!w) window.location.href = url;
    }).catch(function () {});
  }
  var WA_ICON = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.1.2-.3.3-.4.1-.2 0-.3 0-.5 0-.1-.6-1.5-.8-2.1-.2-.5-.4-.5-.6-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1 2.9 1.2 3.1c.1.2 2 3.1 4.9 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.5-.1 1.7-.7 1.9-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.6-.3zM12 2a10 10 0 0 0-8.6 15l-1.3 4.7 4.8-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-2.9.8.8-2.8-.2-.3A8.2 8.2 0 1 1 12 20.2z"/></svg>';
  // ---------- Tipo de entrega: recogida en tienda / a domicilio ----------
  // A domicilio aún no está disponible: se oculta el pedido por WhatsApp y se pide el correo para avisar
  // (formulario nativo de cliente de Shopify → el cliente queda en Clientes con la etiqueta "aviso-domicilio").
  var SHIP_KEY = 'carles_fulfillment';
  function getShip() { try { return localStorage.getItem(SHIP_KEY) === 'home' ? 'home' : 'pickup'; } catch (e) { return 'pickup'; } }
  function setShip(v) {
    try { localStorage.setItem(SHIP_KEY, v); } catch (e) {}
    document.body.classList.toggle('carles-ship-home', v === 'home');
    var opts = document.querySelectorAll('.carles-ship__opt');
    for (var i = 0; i < opts.length; i++) opts[i].classList.toggle('is-active', opts[i].getAttribute('data-ship') === v);
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    try { fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Tipo de entrega': v === 'home' ? 'A domicilio' : 'Recogida en tienda' } }) }); } catch (e) {}
  }
  function notified() { try { return !!localStorage.getItem('carles_home_notified'); } catch (e) { return false; } }
  function buildShip() {
    var ca = isCaLang(), cur = getShip();
    var w = document.createElement('div'); w.className = 'carles-ship'; w.setAttribute('role', 'group');
    [['pickup', ca ? 'Recollida a botiga' : 'Recogida en tienda'], ['home', ca ? 'A domicili' : 'A domicilio']].forEach(function (o) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'carles-ship__opt' + (cur === o[0] ? ' is-active' : '');
      b.setAttribute('data-ship', o[0]); b.textContent = o[1];
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); setShip(o[0]); });
      w.appendChild(b);
    });
    return w;
  }
  function buildNotify() {
    var ca = isCaLang();
    var n = document.createElement('div'); n.className = 'carles-notify';
    var msg = document.createElement('p'); msg.className = 'carles-notify__msg'; msg.textContent = ca ? (WA.home_ca || '') : (WA.home_es || '');
    n.appendChild(msg);
    if (notified()) {
      var ok = document.createElement('p'); ok.className = 'carles-notify__ok'; ok.textContent = ca ? "Gràcies! T'avisarem per correu." : '¡Gracias! Te avisaremos por correo.';
      n.appendChild(ok); return n;
    }
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var f = document.createElement('form'); f.className = 'carles-notify__form'; f.method = 'post'; f.action = root + 'contact#carles-notify'; f.setAttribute('accept-charset', 'UTF-8');
    f.innerHTML = '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="\u2713"><input type="hidden" name="contact[tags]" value="aviso-domicilio,newsletter">';
    var inp = document.createElement('input'); inp.type = 'email'; inp.name = 'contact[email]'; inp.required = true; inp.className = 'carles-notify__input';
    inp.placeholder = ca ? 'El teu correu electrònic' : 'Tu correo electrónico'; inp.setAttribute('autocomplete', 'email');
    var btn = document.createElement('button'); btn.type = 'submit'; btn.className = 'carles-notify__btn'; btn.textContent = ca ? "Avisa'm" : 'Avísame';
    f.appendChild(inp); f.appendChild(btn);
    f.addEventListener('submit', function () { try { sessionStorage.setItem('carles_notify_pending', '1'); } catch (e) {} });
    f.addEventListener('click', function (e) { e.stopPropagation(); });
    n.appendChild(f);
    var lg = document.createElement('p'); lg.className = 'carles-notify__msg'; lg.style.cssText = 'font-size:11px;opacity:.75;margin:8px 0 0';
    lg.textContent = ca ? 'En enviar-lo acceptes rebre aquest avís i comunicacions de Carnisseria Carles. Pots donar-te de baixa quan vulguis.' : 'Al enviarlo aceptas recibir este aviso y comunicaciones de Carnisseria Carles. Puedes darte de baja cuando quieras.';
    n.appendChild(lg); return n;
  }
  function injectShip() {
    if (!WA.on) return;
    document.body.classList.toggle('carles-ship-home', getShip() === 'home');
    var targets = [].slice.call(deliveryLines()).concat([].slice.call(document.querySelectorAll('main .cart__ctas')));
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      if (t.querySelector('.carles-ship')) continue;
      t.insertBefore(buildShip(), t.firstChild);
      var nb = buildNotify();
      var wa = t.querySelector('.carles-hour-wrap');
      if (wa && wa.parentNode === t) t.insertBefore(nb, wa); else t.appendChild(nb);
    }
  }
  // Vuelta del formulario de aviso (Shopify recarga con ?customer_posted=true)
  (function () {
    try {
      if (/[?&]customer_posted=true/.test(location.search) && sessionStorage.getItem('carles_notify_pending')) {
        sessionStorage.removeItem('carles_notify_pending');
        localStorage.setItem('carles_home_notified', '1');
        localStorage.setItem(SHIP_KEY, 'home');
      }
    } catch (e) {}
  })();

  // ---------- Hora de recogida (obligatoria en modo WhatsApp) ----------
  var HOUR_KEY = 'carles_pickup_hour';
  function waHours() { return (WA.hours || []).map(function (h) { return String(h).trim(); }).filter(Boolean); }
  function getHour() {
    var h = ''; try { h = localStorage.getItem(HOUR_KEY) || ''; } catch (e) {}
    return waHours().indexOf(h) > -1 ? h : ''; // si cambian las franjas en el editor, la vieja deja de valer
  }
  function setHour(h) {
    try { if (h) localStorage.setItem(HOUR_KEY, h); else localStorage.removeItem(HOUR_KEY); } catch (e) {}
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    try { fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Hora de recogida': h } }) }); } catch (e) {}
    var sels = document.querySelectorAll('[data-carles-hour]');
    for (var i = 0; i < sels.length; i++) { if (sels[i].value !== h) sels[i].value = h; sels[i].classList.remove('is-invalid'); }
    var errs = document.querySelectorAll('.carles-hour-error');
    for (var j = 0; j < errs.length; j++) errs[j].hidden = true;
  }
  function fillHourSelect(sel) {
    if (sel.getAttribute('data-hour-ready')) return;
    sel.setAttribute('data-hour-ready', '1');
    var ca = isCaLang();
    var o0 = document.createElement('option'); o0.value = ''; o0.textContent = ca ? "Tria l'hora de recollida" : 'Elige la hora de recogida';
    sel.appendChild(o0);
    waHours().forEach(function (h) { var o = document.createElement('option'); o.value = h; o.textContent = h; sel.appendChild(o); });
    sel.value = getHour();
    sel.addEventListener('change', function () { setHour(sel.value); });
  }
  function hourMissing() {
    if (!waHours().length || getHour()) return false;
    var sels = document.querySelectorAll('[data-carles-hour]'), first = null;
    for (var i = 0; i < sels.length; i++) { sels[i].classList.add('is-invalid'); var r = sels[i].getBoundingClientRect(); if (!first && r.width > 0) first = sels[i]; }
    var errs = document.querySelectorAll('.carles-hour-error');
    for (var j = 0; j < errs.length; j++) errs[j].hidden = false;
    if (first) { try { first.focus(); first.scrollIntoView({ block: 'center' }); } catch (e) {} }
    return true;
  }
  function injectHourSelect() {
    if (!WA.on || !waHours().length) return;
    var lines = deliveryLines();
    for (var i = 0; i < lines.length; i++) {
      if (lines[i].querySelector('.carles-hour-wrap')) continue;
      var ca = isCaLang();
      var w = document.createElement('div'); w.className = 'carles-hour-wrap';
      var sel = document.createElement('select'); sel.className = 'carles-hour-select'; sel.setAttribute('data-carles-hour', ''); sel.setAttribute('aria-label', ca ? 'Hora de recollida' : 'Hora de recogida');
      var err = document.createElement('p'); err.className = 'carles-hour-error'; err.hidden = true; err.textContent = ca ? "Tria l'hora de recollida per continuar." : 'Elige la hora de recogida para continuar.';
      w.appendChild(sel); w.appendChild(err); lines[i].appendChild(w);
    }
    var all = document.querySelectorAll('[data-carles-hour]');
    for (var k = 0; k < all.length; k++) fillHourSelect(all[k]);
  }

  // Botones renderizados en Liquid (página /cart): icono + click delegado
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-carles-wa]');
    if (!b || !WA.on) return;
    e.preventDefault(); waOpen();
  });
  function injectWhatsAppBtn() {
    if (!WA.on) return;
    var liq = document.querySelectorAll('[data-carles-wa]:not([data-wa-icon])');
    for (var j = 0; j < liq.length; j++) { liq[j].setAttribute('data-wa-icon', '1'); liq[j].insertAdjacentHTML('afterbegin', WA_ICON); }
    var footers = document.querySelectorAll('.i-minicart-container__snap--footer');
    for (var i = 0; i < footers.length; i++) {
      var f = footers[i];
      if (f.querySelector('.carles-wa-btn')) continue;
      var a = document.createElement('a');
      a.className = 'carles-wa-btn';
      a.href = '#';
      a.setAttribute('role', 'button');
      a.innerHTML = WA_ICON + '<span>' + (isCaLang() ? (WA.btn_ca || 'Fer la comanda per WhatsApp') : (WA.btn_es || 'Hacer el pedido por WhatsApp')) + '</span>';
      a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); waOpen(); });
      f.appendChild(a);
    }
  }

  // ---------- Loop de sincronización ----------
  function tick() { setupScrollWrapper(); applyText(); cartTextCa(); injectChanger(); injectUpsellBar(); fixUpsellKilos(); renameTotalLabel(); applyOptimisticQty(); syncScrollLock(); injectWhatsAppBtn(); injectHourSelect(); injectShip(); }
  function onMinicartMutation() { applyOptimisticQty(); schedule(); } // re-aplica el optimista síncrono (antes del paint)
  var scheduled = false;
  function schedule() { if (scheduled) return; scheduled = true; (window.requestAnimationFrame || function (f) { setTimeout(f, 16); })(function () { scheduled = false; tick(); }); }

  window.addEventListener('cartUpdate', schedule);
  window.addEventListener('cartToggle', schedule);
  window.addEventListener('carles:delivery-change', function () { applyText(); });

  function start() {
    carlesWasOpen = document.body.classList.contains('open-cart');
    loadPpkMap();
    tick();
    // N2: observar SOLO el minicart (no todo el body) -> menos repintados = más rápido.
    // onMinicartMutation re-aplica el update optimista síncrono antes de programar el tick.
    try {
      var target = document.querySelector('i-minicart') || document.querySelector('.i-minicart-container') || document.body;
      new MutationObserver(onMinicartMutation).observe(target, { childList: true, subtree: true });
    } catch (e) {}
    // Observer de la clase de body -> abrir/cerrar (scroll-lock + slide de cierre)
    try {
      new MutationObserver(onBodyClassChange).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    } catch (e) {}
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
